/**
 * Clipping Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.8.25
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { TagDetailsResponse } from './tagDetailsResponse';

export interface TagResponseItem { 
    id: string;
    value?: string;
    colorCode?: string;
    fill?: boolean;
    screenshot?: boolean;
    translate?: boolean;
    langs?: Array<TagResponseItem.LangsEnum>;
    details?: Array<TagDetailsResponse>;
    categoryId?: string;
}
export namespace TagResponseItem {
    export type LangsEnum = 'MK' | 'EN' | 'AL';
    export const LangsEnum = {
        MK: 'MK' as LangsEnum,
        EN: 'EN' as LangsEnum,
        AL: 'AL' as LangsEnum
    };
}